import Layout from "layouts/Layout";
import Auth from "modules/Auth/Middleware/Auth";
import RaffleEventsContent from "modules/RaffleEvents";

import React from "react";
import { setTitle } from "utilities/helper/setTitle";

const RaffleEventsPage: React.FC = () => {
  setTitle("Event");
  return (
    <Auth>
      <Layout>
        <RaffleEventsContent />
      </Layout>
    </Auth>
  );
};

export default RaffleEventsPage;
